
$(document).ready(function(){
  $('.solo-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000
  })

  $('.custom-carousel').slick({
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    arrows: true,
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.profile-carousel').slick({
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

});
